module.exports = __webpack_public_path__ + "static/media/icon-google-play-primary.4ab66cf6.svg";